/* CarGauge Task 10: global overlay accessibility (no new features, no new endpoints).
   - Mobile cart panel (#cart-mobile): inert while closed, focus move/trap/restore, Escape, aria-expanded on triggers.
   - Newsletter popup (#halo_newsletter): focus trap, Escape, focus restore. Subscription/cookie logic stays in theme.min.js.
   Open/close state is still owned by theme.min.js (body.open_Cart, #halo_newsletter display); this file only observes it. */
(function () {
  'use strict';
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function visibleFocusables(root) {
    return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
    });
  }
  function trap(e, root) {
    if (e.key !== 'Tab') return;
    var items = visibleFocusables(root);
    if (!items.length) { e.preventDefault(); root.focus(); return; }
    var first = items[0], last = items[items.length - 1], active = document.activeElement;
    if (!root.contains(active)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  }
  function isEditable(el) {
    return !!el && /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName);
  }

  /* ---------- mobile cart panel ---------- */
  function initCartPanel() {
    var panel = document.getElementById('cart-mobile');
    if (!panel) return;
    var closeBtn = panel.querySelector('[data-close-cart-preview]');
    var lastTrigger = null;
    var isOpen = false;

    function setTriggers(expanded) {
      Array.prototype.forEach.call(document.querySelectorAll('button[data-cart-preview]'), function (b) {
        b.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }
    function apply(open) {
      if (open === isOpen) return;
      isOpen = open;
      if (open) {
        panel.removeAttribute('inert');
        panel.setAttribute('aria-hidden', 'false');
        setTriggers(true);
        window.setTimeout(function () { (closeBtn || panel).focus(); }, 30);
      } else {
        if (panel.contains(document.activeElement)) {
          var back = lastTrigger && document.contains(lastTrigger) ? lastTrigger : null;
          if (back) back.focus();
        }
        panel.setAttribute('inert', '');
        panel.setAttribute('aria-hidden', 'true');
        setTriggers(false);
      }
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-cart-preview]') : null;
      if (t) lastTrigger = t;
    }, true);
    panel.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); if (closeBtn) closeBtn.click(); return; }
      trap(e, panel);
    });
    panel.setAttribute('tabindex', '-1');
    var sync = function () { apply(document.body.classList.contains('open_Cart')); };
    new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    isOpen = !document.body.classList.contains('open_Cart');
    sync();
  }

  /* ---------- newsletter popup ---------- */
  function initNewsletter() {
    var wrap = document.getElementById('halo_newsletter');
    if (!wrap) return;
    var dialog = wrap.querySelector('.newsletterPopup');
    var closeBtn = wrap.querySelector('[data-close-newsletter-popup]');
    if (!dialog) return;
    var visible = false, returnTo = null;

    function isVisible() { return window.getComputedStyle(wrap).display !== 'none'; }
    function sync() {
      var now = isVisible();
      if (now === visible) return;
      visible = now;
      if (now) {
        returnTo = document.activeElement;
        if (!isEditable(returnTo)) window.setTimeout(function () { (closeBtn || dialog).focus(); }, 30);
      } else if (returnTo && document.contains(returnTo) && returnTo !== document.body) {
        returnTo.focus();
        returnTo = null;
      }
    }
    document.addEventListener('keydown', function (e) {
      if (!visible) return;
      if (e.key === 'Escape') { e.preventDefault(); if (closeBtn) closeBtn.click(); return; }
      if (dialog.contains(document.activeElement) || document.activeElement === document.body) trap(e, dialog);
    });
    new MutationObserver(sync).observe(wrap, { attributes: true, attributeFilter: ['style', 'class'] });
    sync();
  }

  function init() { initCartPanel(); initNewsletter(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
